import { useDispatch, useSelector } from "react-redux";
import { callAuthAPI, callMyProfile } from "../../../../Store/api.slice";
import { getBillingProfileIdValue } from "../../../../Store/purchase.slice"
import React, { useCallback, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Alert from "@material-ui/lab/Alert";
import { TextField } from "formik-material-ui";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import Box from "@material-ui/core/Box";
import PurchaseInfo from "../../Common/CartInfo";
import { getAllParkers, getPayorData } from "../../../../Store/purchase.slice";
import { isEmpty } from "lodash";
import { useHistory } from "react-router";
import { Typography } from "@material-ui/core";
import { createApolloFetch } from "apollo-fetch";
import { Amplify } from 'aws-amplify';
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';


import '@aws-amplify/ui-react/styles.css';

const { REACT_APP_API_URL, REACT_APP_API_URL_LOCAL } = process.env;
const apiUrl = REACT_APP_API_URL && REACT_APP_API_URL.startsWith('http') ? REACT_APP_API_URL : REACT_APP_API_URL_LOCAL || '';


Amplify.configure({
    aws_project_region: process.env.REACT_APP_AWS_REGION,
    aws_cognito_region: process.env.REACT_APP_AWS_REGION,
    aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOL_ID,
    aws_user_pools_web_client_id: process.env.REACT_APP_AWS_APP_CLIENT_ID,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
});

function AuthPage() {
    const history = useHistory();
    const dispatch = useDispatch();
    const parkers = useSelector(getAllParkers);
    const payorData = useSelector(getPayorData);
    const billingProfileId = useSelector(getBillingProfileIdValue);
    const { user } = useAuthenticator();
    const userId = user?.attributes?.sub;
    const userToken = user?.getSignInUserSession()?.getIdToken()?.getJwtToken();
   

    async function callListSubscriptions(id, token, billingProfileId) {
        const graphQL = createApolloFetch({ uri: `${apiUrl}/graphql` });
        graphQL.use(({ options }, next) => {
            options.headers = options.headers || {};
            options.headers['Authorization'] = `Bearer ${token}`;
            next();
        });
        const filters = [
            {
                model: 'PAYOR',
                field: 'cognito_sub',
                op: 'EQ',
                value: id,
            },
            {
                model: 'BILLING_PROFILE',
                field: 'validation_only',
                op: 'EQ',
                value: false
            },
            {
                model: 'BILLING_PROFILE',
                field: 'id',
                op: 'EQ',
                value: billingProfileId,
            }
        ]

        const query =
            `
            query listSubscriptions($filters: [Filter]) {
                listSubscriptions(filters: $filters) {
                    subscriptions {
                        id
                        subscription_name
                        billing_profile {
                            id
                            name
                        }
                        payor {
                            id
                            cognito_sub
                        }
                    }
                }
            }
            `;
        const variables = { filters }
        const { errors, data } = await graphQL({ query, variables })

        if (errors) {
            return "Internal Error";
        }

        if (data.listSubscriptions.subscriptions.length) {
            history.push('/subscription')
        } else {
            history.push('/payor')
        }
    }

    useEffect(() => {
        if (!parkers.length) {
            history.push('/');
        } else if (isEmpty(payorData) && !isEmpty(userId) && !isEmpty(userToken)) {
            dispatch(callMyProfile({ id: userId, token: userToken }))
        } else if (!isEmpty(userId) && !isEmpty(userToken)) {
            callListSubscriptions(userId, userToken, billingProfileId);
        }
    }, [userId, userToken, dispatch, history, parkers.length, payorData, billingProfileId]);



    return (
        <Grid container>
            <Grid item xs={12}><LinearProgress variant="determinate" value={60} /></Grid>
            <Grid item xs={12} md={7}>
                <Authenticator loginMechanisms={['email']} signUpAttributes={['given_name', 'family_name']} passwordSettings={{
                    passwordPolicyMinLength: 12,
                    passwordPolicyCharacters: []
                }}>
                    {() => (
                        <main>
                            <h1>Successfully logged in</h1>
                        </main>
                    )}
                </Authenticator>
            </Grid>
            <Grid item xs={12} md={5}>
                <Box m={3}>
                    <PurchaseInfo />
                </Box>
            </Grid>
        </Grid>
    )
}

export default React.memo(AuthPage);
